export const LAST = 'LAST';
export const CURRENT = 'CURRENT';
export const EMPLOYEE = 'EMPLOYEE';
export const CHILD = 'CHILD';

export const PERSON_TYPE = {
    CHILD,
    EMPLOYEE,
};

export const API_ZONED_DATE_TIME_FORMAT = 'YYYY-MM-DDTHH:mm:ss+Z';
